import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  ButtonGroup,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Card,
  Alert,
  OverlayTrigger,
  Tooltip,
  Dropdown,
} from "react-bootstrap";

import toastr from "toastr";
import * as Yup from "yup";
import moment from "moment";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

//Tabla, Navbar y Sidebar
import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

//Redux

import {
  getPlan,
  savePlan,
  deletePlan,
  editPlan,
  cleanFail
} from "../../redux/planCarrera/Plan/actions";

import { getEmployeesResponsible } from "../../redux/capacitacionDesarrollo/TrainingEvents/actions";
import { getAllActiveEmployees } from "../../redux/employees/actions";
import { getStatus } from "../../redux/planCarrera/Estados/actions";
import { getPlanAcciones } from "../../redux/evaluacion_desempenio/plan_accion/actions";


import messages from "../../redux/messages";
import SidebarDashboard from "../../components/SidebarDashboard";

const Plans = (props) => {
  const filters = [
    { id: "estado", desc: "Nombre del Estado" },
    { id: "tipo_plan", desc: "Tipo de Plan" },
    { id: "colaborador_nombre", desc: "Nombre del Colaborador" },
    { id: "colaborador_codigo", desc: "Código del Colaborador" },
    { id: "empresa_nombre", desc: "Nombre de la Empresa" },
    { id: "empresa_codigo", desc: "Código de la Empresa" },
    { id: "division_personal_descripcion", desc: "Nombre de la Zona" },
    { id: "division_personal_codigo", desc: "Código de la Zona" },
    { id: "responsable_nombre", desc: "Nombre del Responsable" },
    { id: "responsable_codigo", desc: "Código del Responsable" }

  ];

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [detailsItem, setDetailsItem] = useState(false)

  //
  const [showModal, setShowModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false)
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  //

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "estado",
    desc: "Nombre del Estado",
  });

  const dispatch = useDispatch();

  //Validacion del form
  const schema = Yup.object().shape({
    colaborador: Yup.string().required("**Campo requerido"),
    responsable: Yup.string().required("**Campo requerido"),
    tipo_plan: Yup.string().required("**Campo requerido"),
    estado: Yup.string().required("**Campo requerido"),
    fecha_inicio: Yup.date()
      .required("**Campo requerido")
      .test("fecha_inicio", "La fecha de inicio debe ser anterior a la fecha de fin", function (value) {
        return value <= this.parent.fecha_fin;
      }),
    fecha_fin: Yup.date()
      .required("**Campo requerido")
      .min(Yup.ref("fecha_inicio"), "La fecha de fin debe ser posterior a la fecha de inicio"),
    objetivo: Yup.string()
      .required("**Campo requerido")
      .matches(
        /^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?!¡/\-_%#.]+$/,
        "**Solo admite letras,numeros y los siguientes caracteres @$¿?!¡/-_%#."
      ),
    plan_documento: Yup.mixed()
      .test(
        "fileRequired",
        "**El archivo no puede estar vacío",
        value => {
          if (!value) {
            return true;
          }
          return value && value.size > 0;
        }
      )

  });

  const {
    loading,
    saveLoading,
    plansLength,
    plans,
    planError,
    formPlanError,
  } = useSelector((store) => store.planCarreraPlan);

  const {
    loaderpersonResponsible,
    personResponsible
  } = useSelector((store) => store.trainingEvents);

  const { employees, loaderAllEmployees } = useSelector(
    (store) => store.employees
  );

  const {
    loading: loadingStatuses,
    statuses
  } = useSelector((store) => store.planCarreraStatus);

  const { loaderPlanAccion, planAccion } = useSelector(
    (store) => store.planAccion
  );

  const pages = Math.ceil(plansLength / limit);


  //Valores para los typeaheads

  const personResponsibleOptions = personResponsible
    ? personResponsible.data.map((item) => ({
      id: item.id,
      label: item.nombre
        ? `${item.codigo} / ${item.nombre.toUpperCase()}`
        : "",
      item: item,
    }))
    : [];

  const employeesOptions = employees
    ? employees.map((item) => ({
      id: item.id,
      label: item.codigo
        ? `${item.codigo} / ${item.nombre.toUpperCase()}`
        : "",
      item: item,
    }))
    : [];

  const statusesOptions = statuses
    ? statuses.map((item) => ({
      id: item.id,
      label: item.nombre,
      item: item,
    }))
    : [];

  const planAccionesOptions = planAccion
    ? planAccion.data.map((item) => ({
      id: item.id,
      label: item.descripcion,
      item: item,
    }))
    : [];

  const estadoPendiente = statuses.filter((item) => item.nombre.toUpperCase() === "PENDIENTE")

  const goToPlanIndividual = (value, idPlan, codFuncion) => {
    if(!value.row.original?.list_plan_accion?.[0].responsable || !value.row.original.objetivo ){
        toastr.error("Primero debe ingresar el objetivo y el responsable del plan.")
        return;
    }
    props.history.push(`/plan-carrera/plan-de-carrera-individual/${idPlan}/${codFuncion}`);
  }

  const onShowDetails = (data) => {
    setDetailsItem(data)
    setShowDetailsModal(true)
  }

  //Datos para el custom table

  const columns = [
    {
      Header: "Tipo de Plan",
      accessor: "list_tipo_plan[0].descripcion",
      Filter: ""
    },
    {
      Header: "Código",
      accessor: "list_plan_accion[0].list_empleado[0].codigo",
      Filter: ""
    },
    {
      Header: "Colaborador",
      accessor: "list_plan_accion[0].list_empleado[0].nombre",
      Filter: ""
    },
    {
      Header: "Responsable",
      accessor: "list_plan_accion[0].list_responsable[0].nombre",
      Filter: ""
    },
    {
      Header: "Estado",
      accessor: "list_estado[0].nombre",
      Filter: ""
    },
    {
      Header: "Fecha de inicio",
      accessor: "fecha_inicio",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_inicio).format("DD-MM-YYYY")}
        </div>
      ),
    },
    {
      Header: "Fecha Fin",
      accessor: "fecha_fin",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_fin).format("DD-MM-YYYY")}
        </div>
      ),
    },
    {
      Header: "Avance",
      accessor: "avance",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.avance || "0.00"}%
        </div>
      ),
    },

    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <OverlayTrigger overlay={<Tooltip>Ver más</Tooltip>}>
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onShowDetails(value.row.original)}
            >
              <i className="material-icons">more_horiz</i>
            </Button>
          </OverlayTrigger>

          <OverlayTrigger overlay={<Tooltip>Ver Plan Individual</Tooltip>}>
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => goToPlanIndividual(value,value.row.original.id, value.row.original.list_funciones[0].codigo)}
            >
              <i className="material-icons">assignment</i>
            </Button>
          </OverlayTrigger>


          <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>

          <OverlayTrigger overlay={<Tooltip>Eliminar</Tooltip>}>
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>

        </div>
      ),
    },
  ];

  // Metodos de planes

  const getAPlan = (off = offset, lim = limit, filt = filter) =>
    dispatch(
      getPlan({
        offset: off,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt

      })
    );

  useEffect(() => {
    getAPlan();
    dispatch(getEmployeesResponsible({ filter: "Responsable_Carrera" }))
    dispatch(getAllActiveEmployees())
    dispatch(getStatus());
    dispatch(getPlanAcciones());
  }, []);

  const addPlan = () => {
    dispatch(cleanFail())
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    dispatch(cleanFail())
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(0);
    setCurrentPage(1);
    getAPlan(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const formData = new FormData()
    formData.append("colaborador", req.colaborador)
    formData.append("responsable", req.responsable)
    formData.append("estado", req.estado)
    formData.append("tipo_plan", req.tipo_plan)
    formData.append("objetivo", req.objetivo)

    if (req.plan_documento) {
      formData.append("plan_documento", req.plan_documento);
    }


    if (!edit) {

      formData.append("fecha_inicio", moment(req.fecha_inicio).format("DD-MM-YYYY"))
      formData.append("fecha_fin", moment(req.fecha_fin).format("DD-MM-YYYY"))
      dispatch(savePlan(formData, setShowModal));
    } else {
      formData.append("fecha_inicio", req.fecha_inicio)
      formData.append("fecha_fin", req.fecha_fin)
      dispatch(editPlan(editItem.id, editItem.list_plan_accion[0].id, formData, { responsable: req.responsable }, index, setShowModal));
    }

  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAPlan(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    debugger
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deletePlan(id, index));
      window.alert("Se borró este plan");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      {console.log("planes", estadoPendiente)}
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6>Planes</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      onClick={() => addPlan()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            plansLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={plans} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={plansLength}
                  pages={pages}

                />
              </>
            )
          )}
          {!loading && plansLength === 0 && planError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
          {!!planError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {planError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);

        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            estado: edit ? editItem.estado : estadoPendiente?.[0]?.id,
            tipo_plan: edit ? editItem.list_tipo_plan[0].id : "",
            colaborador: edit ? editItem.list_plan_accion[0].list_empleado[0].id : "",
            responsable: edit && editItem.list_plan_accion[0]?.list_responsable?.[0] ? editItem.list_plan_accion[0].list_responsable[0].id : "",
            fecha_inicio: edit ? editItem.fecha_inicio : moment().format("YYYY-MM-DD"),
            fecha_fin: edit ? editItem.fecha_fin : moment().add(1, "day").format("YYYY-MM-DD"),
            objetivo: edit && editItem?.objetivo ? editItem?.objetivo : "",
            plan_documento: ""

          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar plan" : "Crear plan"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formPlanError && (
                  <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                    {formPlanError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Tipo de Plan:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <Typeahead
                        id="tipo_plan"
                        name="tipo_plan"
                        isInvalid={touched.tipo_plan && errors.tipo_plan}
                        isValid={touched.tipo_plan && !errors.tipo_plan}
                        onBlur={handleBlur("tipo_plan")}
                        placeholder="Seleccione un tipo de plan"
                        options={planAccionesOptions}
                        value={values.tipo_plan}
                        onChange={(selected) => {
                          setFieldValue(
                            "tipo_plan",
                            selected.length > 0 ? selected[0].id : "",

                          );

                        }}
                        defaultInputValue={edit ? `${editItem.list_tipo_plan[0].descripcion.toUpperCase()}`
                          : ""}

                      >

                      </Typeahead>
                      <div className="text-danger">
                        {errors.tipo_plan}
                      </div>

                    </Col>
                  </Row>

                  <Form.Label column sm="12" md="12">
                    Colaborador:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <Typeahead
                        id="colaborador"
                        name="colaborador"
                        isInvalid={touched.colaborador && errors.colaborador}
                        isValid={touched.colaborador && !errors.colaborador}
                        onBlur={handleBlur("colaborador")}
                        placeholder="Seleccione un colaborador"
                        options={employeesOptions}
                        value={values.colaborador}
                        onChange={(selected) => {
                          setFieldValue(
                            "colaborador",
                            selected.length > 0 ? selected[0].id : "",

                          );

                        }}
                        defaultInputValue={edit ? `${editItem.list_plan_accion[0].list_empleado[0].codigo} / ${editItem.list_plan_accion[0].list_empleado[0].nombre.toUpperCase()}`
                          : ""}
                        disabled={edit}

                      >

                      </Typeahead>
                      <div className="text-danger">
                        {errors.colaborador}
                      </div>
                    </Col>
                  </Row>

                  <Form.Label column sm="12" md="12">
                    Responsable:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <Typeahead
                        id="responsable"
                        name="responsable"
                        isInvalid={touched.responsable && errors.responsable}
                        isValid={touched.responsable && !errors.responsable}
                        onBlur={handleBlur("responsable")}
                        placeholder="Seleccione un responsable"
                        options={personResponsibleOptions}
                        value={values.responsable}
                        onChange={(selected) => {
                          setFieldValue(
                            "responsable",
                            selected.length > 0 ? selected[0].id : "",

                          );

                        }}
                        defaultInputValue={edit && editItem.list_plan_accion[0]?.list_responsable?.[0] ? `${editItem.list_plan_accion[0].list_responsable[0].codigo} / ${editItem.list_plan_accion[0].list_responsable[0].nombre.toUpperCase()}`
                          : ""}

                      >

                      </Typeahead>

                      <div className="text-danger">
                        {errors.responsable}
                      </div>
                    </Col>
                  </Row>

                  <Form.Label column sm="12" md="12">
                    Fecha de Inicio:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <input
                        type="date"
                        id="fecha_inicio"
                        name="fecha_inicio"
                        isInvalid={touched.fecha_inicio && errors.fecha_inicio}
                        isValid={touched.fecha_inicio && !errors.fecha_inicio}
                        onBlur={handleBlur("fecha_inicio")}
                        onChange={handleChange}
                        value={moment(values.fecha_inicio).format("YYYY-MM-DD")}
                        style={{
                          padding: "8px 10px",
                          borderRadius: "20px",
                          borderColor: errors.fecha_inicio ? "#ff0000" : "#92929380"
                        }}
                      />
                      <div className="text-danger">
                        {errors.fecha_inicio}
                      </div>
                    </Col>
                  </Row>

                  <Form.Label column sm="12" md="12">
                    Fecha Fin:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <input
                        type="date"
                        id="fecha_fin"
                        name="fecha_fin"
                        isInvalid={touched.fecha_fin && errors.fecha_fin}
                        isValid={touched.fecha_fin && !errors.fecha_fin}
                        onBlur={handleBlur("fecha_fin")}
                        onChange={handleChange}
                        value={moment(values.fecha_fin).format("YYYY-MM-DD")}
                        style={{
                          padding: "8px 10px",
                          borderRadius: "20px",
                          borderColor: errors.fecha_inicio ? "#ff0000" : "#92929380"
                        }}
                      />
                      <div className="text-danger">
                        {errors.fecha_fin}
                      </div>
                    </Col>
                  </Row>

                  {edit && (
                    <>
                      <Form.Label column sm="12" md="12">
                        Estado:
                      </Form.Label>
                      <Row className="d-flex flex-wrap align-items-center">
                        <Col sm={11} xs={11}>
                          <Typeahead
                            id="estado"
                            name="estado"
                            isInvalid={touched.estado && errors.estado}
                            isValid={touched.estado && !errors.estado}
                            onBlur={handleBlur("estado")}
                            placeholder="Seleccione un estado"
                            options={statusesOptions}
                            value={values.estado}
                            onChange={(selected) => {
                              setFieldValue(
                                "estado",
                                selected.length > 0 ? selected[0].id : "",

                              );

                            }}
                            defaultInputValue={edit ? `${editItem.list_estado[0].nombre.toUpperCase()}`
                              : ""}

                          >

                          </Typeahead>

                          <div className="text-danger">
                            {errors.estado}
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}

                  <Form.Label column sm="12" md="12">
                    Objetivo:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                    <Col sm={11} xs={11}>
                      <Form.Control
                        id="objetivo"
                        name="objetivo"
                        isInvalid={touched.objetivo && errors.objetivo}
                        isValid={touched.objetivo && !errors.objetivo}
                        onBlur={handleBlur("objetivo")}
                        onChange={handleChange}
                        value={values.objetivo}
                        className="rounded-pill mb-4"
                        type="text"
                        placeholder="objetivo"
                      ></Form.Control>
                      <div className="text-danger">
                        {errors.objetivo}
                      </div>
                    </Col>
                  </Row>


                  <Form.Label className="custom-file-upload mt-3">
                    <i className="material-icons m-1">upload_file</i>
                    <input
                      type="file"
                      name="plan_documento"
                      id="plan_documento"
                      onChange={(e) => setFieldValue("plan_documento", e.target.files[0])}
                    />
                    {editItem.plan_documento ? "Cambiar archivo" : "Subir archivo"}
                  </Form.Label>
                  <span className="file-name">{values.plan_documento ? `${values.plan_documento.name}` : editItem.plan_documento ? editItem.plan_documento.split("/").pop() : 'No se ha seleccionado un archivo'}</span>
                  {errors.plan_documento && (
                    <div>
                      <span className="text-danger">{errors.plan_documento}</span>
                    </div>
                  )}
                </Form.Group>


              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={saveLoading}
                  type="submit"

                >
                  {" "}
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>


      <Modal
        show={showDetailsModal}
        onHide={() => {
          setShowDetailsModal(false);
          setDetailsItem(null);
        }}
      >
        <Form>
          <Modal.Header closeButton>
            <Modal.Title className="text-muted">
              Más Detalles
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Empresa:
              </Form.Label>
              <Form.Control
                id="empresa"
                name="empresa"
                value={detailsItem ? `${detailsItem?.list_plan_accion?.[0]?.list_empleado?.[0]?.empresa_codigo?.[0]}/${detailsItem.list_plan_accion?.[0]?.list_empleado?.[0]?.empresa?.[0].toUpperCase()}` : ""}
                className="rounded-pill mb-4"
                type="text"
                disabled
              />

              <Form.Label column sm="12" md="12">
                Zona:
              </Form.Label>
              <Form.Control
                id="zona"
                name="zona"
                value={detailsItem ? `${detailsItem?.list_plan_accion?.[0]?.list_empleado?.[0]?.Division_Personal_List?.[0]?.codigo}/ ${detailsItem.list_plan_accion?.[0]?.list_empleado?.[0]?.Division_Personal_List?.[0]?.descripcion.toUpperCase()}` : ""}
                className="rounded-pill mb-4"
                type="text"
                disabled
              />
              <Form.Label column sm="12" md="12">
                Objetivo:
              </Form.Label>
              <Form.Control
                id="objetivo"
                name="objetivo"
                value={detailsItem ? detailsItem?.objetivo : ""}
                className="rounded-pill mb-4"
                type="text"
                disabled
              />




            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => {
                setShowDetailsModal(false)
                setDetailsItem(null)
              }}
            >
              Cerrar
            </Button>

          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Plans;
